import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';

const GET_TRACKS = gql`
  query GetTracks($input: GetTracksInput!) {
    getTracks(input: $input) {
      id
      name
    }
  }
`;

export function useTrackSearch() {
  const { data, loading } = useQuery(GET_TRACKS, {
    variables: { input: {} },
    fetchPolicy: 'cache-and-network',
  });

  const tracks =
    data?.getTracks?.map((track) => ({
      value: track.id,
      label: track.name,
    })) || [];

  return { tracks, loading };
}
